import React from 'react';
import Switch from 'react-bootstrap/esm/Switch';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import firebase from './config/Firebase'
import * as actions from './actions/UserActions'
import routes from './routes';
// import Login from './components/User/Login';
// import history from './history';


class App extends React.Component {

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.props.setCurrentUser(user)
      } else {
        // this.props.setLogout();
        this.props.history.push("/account/login")
      }
    })
  }

  showRouter = (routes) => {
    var result = null;
    if (routes) {
      result = routes.map((item, index) => {
        return (
          <Route
            key={index}
            path={item.path}
            exact={item.exact}
            component={item.main}
          />
        )
      })
    }
    return <Switch>
      {result}
    </Switch>
  }

  render() {
    // var user = firebase.auth().currentUser;
    // if (user) {
      return (
        <div className="App">
          <Navbar />
          {this.showRouter(routes)}
        </div>
      );
    // }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.currentUser
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setCurrentUser: (user) => {
      dispatch(actions.setCurrentUser(user))
    },
    setLogout: () => {
      dispatch(actions.setLogout())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
